import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { FilterTypes, INTIAL_FILTERS, NEW_VEHICLE_FILTERS_LIST } from '../constants/initialFilters';

export type listOfDealersType = {
  dealerName: string;
  dealerId: string;
  isMainDealer: boolean;
};

interface ConfigReducerTypes {
  listOfDealers: listOfDealersType[];
  isImageGalleryOn: boolean;
  isUrlParamsDynamic: boolean;
  dataSource: string;
  isTier3page: boolean;
  marketType: string;
  pageTitle: string;
  pageDescription: string;
  filterGroupsToRender: string[];
  tier3Filters: FilterTypes;
}

const initialState = {
  listOfDealers: [
    { dealerName: 'Audi Test 1', dealerId: '25A70', isMainDealer: true },
    { dealerName: 'Audi Test 2', dealerId: '25A72', isMainDealer: false },
    { dealerName: 'Audi Test 3', dealerId: '25A73', isMainDealer: false },
  ],
  isUrlParamsDynamic: false,
  dataSource: 'jdp',
  isImageGalleryOn: true,
  isTier3page: false,
  marketType: 'USA',
  pageTitle: 'Vehicle Inventory test',
  pageDescription: '',
  filterGroupsToRender: NEW_VEHICLE_FILTERS_LIST,
  tier3Filters: INTIAL_FILTERS,
};

const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    setConfig: (_state, action) => {
      return action.payload;
    },
    setMarket: (state, action) => {
      return { ...state, marketType: action.payload };
    },
  },
});

export const selectAppConfig = (state: RootState) => state.config;

export const { setConfig, setMarket } = appConfigSlice.actions;

export default appConfigSlice.reducer;
